module.exports = __webpack_public_path__ + "img/drawer-background.32103624.jpg";